// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-pay-result[data-v-6086e318]{width:100%;height:100vh}.container-pay-result .content[data-v-6086e318]{width:100%;height:100vh;overflow:hidden}.container-pay-result .content>img[data-v-6086e318]{width:100%;height:100vh;-o-object-fit:cover;object-fit:cover}", ""]);
// Exports
module.exports = exports;
